// Centralised login gate for "İlan Ver" entry points.
//
// Mirrors the pattern already used in AdvertDetail.js: stash the intended
// destination in localStorage under `pageToRedirectAfterLogin`, then send
// the user to /login. Login.js / ForgotPassword.js read this key on success
// and bounce the user back to the original target.
//
// Usage:
//   import requireLogin from "helpers/requireLogin";
//   <button onClick={() => requireLogin(history, isLogged, "/ilanOlustur")}>...</button>
export default function requireLogin(history, isLogged, target) {
  if (isLogged) {
    history.push(target);
    return;
  }
  try {
    localStorage.setItem("pageToRedirectAfterLogin", target);
  } catch (e) {
    // private mode / disabled storage — login still works, user just lands on /
  }
  history.push("/login");
}
